var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _g, _g2, _g3, _g4, _circle, _path20, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3200,
    height: 1800,
    viewBox: "0 0 3200 1800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1292.21 736.736C1303.5 757.729 1302.15 810.979 1287.56 814.731C1281.75 816.227 1269.35 812.562 1256.74 804.976L1264.65 860.864H1217.9L1233.99 786.007C1225.01 775.497 1218.94 762.618 1219.96 748.187C1222.88 706.594 1280.92 715.744 1292.21 736.736Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1295.01 736.854C1286.42 738.464 1269.45 746.394 1255.39 757.855L1253.71 759.263C1252.01 758.365 1250.06 757.855 1247.99 757.855C1241.37 757.855 1236 763.076 1236 769.517C1236 772.146 1236.89 774.572 1238.4 776.523C1235.56 781.189 1233.62 786.101 1232.98 791.152C1223.13 791.152 1187.18 753.968 1223 718.984C1258.81 684 1310.56 733.942 1295.01 736.854Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.31 1022.18L1295.98 1269.45L1361.64 1451.71H1399.08L1308.83 1022.18L1202.31 1022.18Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1179.16 1022.18C1178.15 1107.02 1178.88 1221.25 1176.51 1226.54C1174.93 1230.07 1125.73 1270.24 1028.93 1347.06L1048.23 1379.79C1163.16 1305.85 1223.56 1263.96 1229.43 1254.11C1238.25 1239.33 1282.53 1103.35 1305.56 1022.18H1179.16Z",
    fill: "#F2F2F2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M995.051 1368.93L1027.62 1344.24L1053.9 1375.6C1055.92 1399.19 1063.74 1425.67 1077.36 1455.03L1071.39 1460.01L1023.84 1403.27L1010.55 1381.37L1007.57 1383.86L995.051 1368.93Z",
    fill: "#F2F2F2"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1358.16 1486.69L1360.11 1445.88H1401.02C1420.42 1459.48 1445.75 1470.49 1477 1478.92V1486.69H1402.97L1377.65 1482.8V1486.69H1358.16Z",
    fill: "#F2F2F2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1128.88 998.895L1169.59 999.055C1144.46 1080.01 1130.89 1122.97 1128.88 1127.92C1124.38 1139.07 1133.92 1156.04 1137.99 1165.16C1124.71 1171.09 1126.12 1149.13 1109.36 1156.91C1094.07 1164.01 1082.43 1176.87 1064.75 1165.99C1062.58 1164.65 1060.2 1159.62 1065.95 1155.68C1080.29 1145.88 1100.94 1128.71 1103.73 1123.07C1107.54 1115.36 1115.92 1073.97 1128.88 998.895ZM1373.84 991.32L1429.02 1045.03C1445.08 1051.86 1458.24 1059.41 1468.49 1067.67C1470.8 1070.44 1473.31 1075.76 1462.46 1073.38C1451.61 1071 1440.08 1068.98 1438.04 1072.5C1436.01 1076.03 1442.01 1081.42 1438.25 1086.03C1435.73 1089.1 1427.28 1079.33 1412.89 1056.72L1355.51 1022.96L1373.84 991.32Z",
    fill: "#F2F2F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M1244.58 828.469L1261.42 825.586C1290.43 897.868 1341.06 963.544 1413.33 1022.62L1358.72 1088.81C1286.46 1004.7 1241.92 917.917 1244.58 828.469Z",
    fill: "#F2F2F2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1171.14 1039.67H1321.15C1286.4 955.37 1269.02 883.756 1269.02 824.832L1223.77 818.105C1188.21 875.165 1178.17 945.417 1171.14 1039.67Z",
    fill: "#F2F2F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1225.78 818.105C1229.32 818.227 1234.7 818.446 1241.93 818.762L1252.87 849.935C1254.02 887.942 1260.78 964.537 1273.13 1079.72L1174.8 1079.71C1175.06 1087.67 1175.48 1095.7 1176.07 1103.81H1102.96C1113.9 980.711 1153.83 885.477 1222.78 818.105L1222.81 818.144L1222.83 818.105H1225.78Z",
    fill: "#F2F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1202.31 1080.49L1174.82 1080.48C1173.62 1044.82 1175.77 1010.66 1181.28 977.98C1184.1 1027.54 1191.1 1061.71 1202.31 1080.49Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1196.68 1020.24L1245.17 997.747V1020.24H1196.68Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2132.69 314H1495.17C1454.76 314 1422 346.761 1422 387.173V1344.83C1422 1385.24 1454.76 1418 1495.17 1418H2132.69C2173.11 1418 2205.87 1385.24 2205.87 1344.83V387.173C2205.87 346.761 2173.11 314 2132.69 314Z",
    fill: "white",
    stroke: "#F4F1F1",
    strokeWidth: 4.09264
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M2132.69 314H1495.17C1454.76 314 1422 346.761 1422 387.173V1344.83C1422 1385.24 1454.76 1418 1495.17 1418H2132.69C2173.11 1418 2205.87 1385.24 2205.87 1344.83V387.173C2205.87 346.761 2173.11 314 2132.69 314Z",
    fill: "#007AFF",
    fillOpacity: 0.01,
    stroke: "#F4F1F1",
    strokeWidth: 4.09264
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2090.62 396.32H1537.25C1522.09 396.32 1509.81 408.605 1509.81 423.76C1509.81 438.915 1522.09 451.2 1537.25 451.2H2090.62C2105.77 451.2 2118.06 438.915 2118.06 423.76C2118.06 408.605 2105.77 396.32 2090.62 396.32Z",
    fill: "#F2F2F2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M2096.42 553H1660.58C1648.66 553 1639 562.85 1639 575C1639 587.15 1648.66 597 1660.58 597H2096.42C2108.34 597 2118 587.15 2118 575C2118 562.85 2108.34 553 2096.42 553Z",
    fill: "#F2F2F2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2096.42 641H1660.58C1648.66 641 1639 650.85 1639 663C1639 675.15 1648.66 685 1660.58 685H2096.42C2108.34 685 2118 675.15 2118 663C2118 650.85 2108.34 641 2096.42 641Z",
    fill: "#F2F2F2"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M2096.42 729H1660.58C1648.66 729 1639 738.85 1639 751C1639 763.15 1648.66 773 1660.58 773H2096.42C2108.34 773 2118 763.15 2118 751C2118 738.85 2108.34 729 2096.42 729Z",
    fill: "#F2F2F2"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2096.42 817H1660.58C1648.66 817 1639 826.85 1639 839C1639 851.15 1648.66 861 1660.58 861H2096.42C2108.34 861 2118 851.15 2118 839C2118 826.85 2108.34 817 2096.42 817Z",
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1580.17 555.733C1581.28 556.826 1581.28 558.466 1580.17 559.559L1543.25 596.18C1542.15 597.273 1540.49 597.273 1539.39 596.18L1537.46 594.267L1519.83 577.05C1518.72 575.957 1518.72 574.317 1519.83 573.224L1521.76 571.311C1522.86 570.218 1524.51 570.218 1525.61 571.311L1541.32 586.888L1574.39 554.093C1575.49 553 1577.14 553 1578.24 554.093L1580.17 555.733Z",
    fill: "#F2F2F2"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1580.17 643.733C1581.28 644.826 1581.28 646.466 1580.17 647.559L1543.25 684.18C1542.15 685.273 1540.49 685.273 1539.39 684.18L1537.46 682.267L1519.83 665.05C1518.72 663.957 1518.72 662.317 1519.83 661.224L1521.76 659.311C1522.86 658.218 1524.51 658.218 1525.61 659.311L1541.32 674.888L1574.39 642.093C1575.49 641 1577.14 641 1578.24 642.093L1580.17 643.733Z",
    fill: "#F2F2F2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1580.17 731.733C1581.28 732.826 1581.28 734.466 1580.17 735.559L1543.25 772.18C1542.15 773.273 1540.49 773.273 1539.39 772.18L1537.46 770.267L1519.83 753.05C1518.72 751.957 1518.72 750.317 1519.83 749.224L1521.76 747.311C1522.86 746.218 1524.51 746.218 1525.61 747.311L1541.32 762.888L1574.39 730.093C1575.49 729 1577.14 729 1578.24 730.093L1580.17 731.733Z",
    fill: "#F2F2F2"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1580.17 819.733C1581.28 820.826 1581.28 822.466 1580.17 823.559L1543.25 860.18C1542.15 861.273 1540.49 861.273 1539.39 860.18L1537.46 858.267L1519.83 841.05C1518.72 839.957 1518.72 838.317 1519.83 837.224L1521.76 835.311C1522.86 834.218 1524.51 834.218 1525.61 835.311L1541.32 850.888L1574.39 818.093C1575.49 817 1577.14 817 1578.24 818.093L1580.17 819.733Z",
    fill: "#F2F2F2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 1813.5,
    cy: 1131.5,
    r: 184.5,
    fill: "#2D72FE"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M1873 1120.72H1827.31V1076H1799.69V1120.72H1754V1146.28H1799.69V1191H1827.31V1146.28H1873V1120.72Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1519 553H1581V597H1519V553Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1519 641H1581V685H1519V641Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1519 729H1581V773H1519V729Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1519 817H1581V861H1519V817Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateRole);
export default __webpack_public_path__ + "static/media/create-role.dbf9fb9b955f6423b562c2a50fba8443.svg";
export { ForwardRef as ReactComponent };